import { login, logout, getUserInfo, resetPassword } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    id: '',
    person: '',
    phone: '',
    area: '',
    groupid: '',
    email: '',
    name: '',
    lastlogin: '',
    roles: [],
    token: getToken(),
    setting: {
      articlePlatform: []
    },
    su: 0
  },
  mutations: {
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_PERSON: (state, person) => {
      state.person = person
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_AREA: (state, area) => {
      state.area = area
    },
    SET_GROUPID: (state, groupid) => {
      state.groupid = groupid
    },
    SET_BRANCHID: (state, branchid) => {
      state.branchid = branchid
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_LASTLOGIN: (state, lastlogin) => {
      state.lastlogin = lastlogin
    },
    SET_SU: (state, su) => {
      state.su = su
    }
  },
  actions: {
    Login ({ commit }, userInfo) {
      const email = userInfo.email.trim()
      return new Promise((resolve, reject) => {
        login(email, userInfo.password).then(response => {
          // const data = response.data
          // console.log(response)
          commit('SET_TOKEN', response.token)
          setToken(response.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetUserInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(response => {
          if (!response) {
            reject(Error('error'))
          }
          commit('SET_ID', response.user.id)
          commit('SET_PERSON', response.user.contact_person)
          commit('SET_PHONE', response.user.phone_number)
          commit('SET_AREA', response.user.area)
          commit('SET_GROUPID', response.user.customer_group_id)
          commit('SET_BRANCHID', response.user.branches_id)
          commit('SET_EMAIL', response.user.email)
          commit('SET_NAME', response.user.name)
          commit('SET_LASTLOGIN', response.user.last_login)
          commit('SET_SU', response.user.is_superuser)
          let roles = ['unknown']
          response.user.groups.forEach((group) => {
            roles.push(group.code)
          })
          commit('SET_ROLES', roles)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(res => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // fedout
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // 动态修改权限
    // ChangeRoles({ commit }, role) {
    //   return new Promise(resolve => {
    //     commit('SET_TOKEN', role)
    //     setToken(role)
    //     getUserInfo(role).then(response => {
    //       const data = response.data
    //       commit('SET_ROLES', data.roles)
    //       commit('SET_NAME', data.name)
    //       commit('SET_AVATAR', data.avatar)
    //       commit('SET_INTRODUCTION', data.introduction)
    //       resolve()
    //     })
    //   })
    // }

    ResetPassword ({ commit, state }, credentials) {
      const data = {
        token: state.token,
        email: state.email,
        password: credentials.password,
        new_password: credentials.new_password,
        new_password_confirmation: credentials.new_password_confirmation
      }
      // console.log(data)
      return new Promise((resolve, reject) => {
        resetPassword(data).then(response => {
          if (!response) {
            reject(Error('error'))
          }
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js